export default __webpack_public_path__ + "locales/sq-AL/PrivacyPage.json?hash=9ee737019b53716eeef571b651f2b593";